export default __webpack_public_path__ + "static/media/ArmButtonActive.d26aa548.svg";